var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _ellipse2, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _ellipse3, _path40, _path41, _path42, _path43, _ellipse4, _path44, _path45, _path46, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonster5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 190,
    viewBox: "0 0 187 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 93.5117,
    cy: 166.313,
    rx: 60.5898,
    ry: 13.8766,
    fill: "url(#paint0_radial_14011_169619)",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.9509 62.8739C51.9509 62.8739 39.6716 73.5619 33.7326 93.101C33.7326 93.101 27.8299 113.722 37.7166 120.802C37.7166 120.802 45.7877 126.477 51.1659 117.867C51.1659 117.867 46.3674 81.045 56.469 60.2593C56.469 60.2593 56.6162 59.2174 55.9904 59.2248C55.4384 59.2152 54.2839 59.9829 51.9509 62.8739Z",
    fill: "url(#paint1_linear_14011_169619)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5869 118.289C33.329 120.366 34.0766 122.168 35.2571 122.312C36.4375 122.455 37.6005 120.888 37.8585 118.812C38.112 116.735 37.3644 114.933 36.1839 114.79C36.1359 114.785 36.0834 114.781 36.0353 114.781C34.9073 114.781 33.8318 116.3 33.5869 118.289Z",
    fill: "url(#paint2_linear_14011_169619)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3198 122.061C39.0662 124.137 39.8138 125.94 40.9944 126.083C42.1705 126.227 43.3379 124.66 43.5915 122.583C43.8494 120.507 43.1018 118.705 41.9213 118.561C41.8732 118.557 41.8207 118.552 41.7726 118.552C40.6446 118.552 39.569 120.072 39.3198 122.061Z",
    fill: "url(#paint3_linear_14011_169619)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4955 118.625C46.3383 118.881 45.7688 120.749 46.2344 122.792C46.6954 124.835 48.0062 126.276 49.1679 126.019C50.325 125.758 50.8946 123.89 50.429 121.852C50.0041 119.966 48.856 118.593 47.7712 118.593C47.6763 118.593 47.5859 118.602 47.4955 118.625Z",
    fill: "url(#paint4_linear_14011_169619)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M52.3943 62.3299C52.3943 62.3299 46.7934 103.18 48.4119 118.595C48.4119 118.595 46.4369 118.317 46.2618 120.031C46.2618 120.031 45.8467 94.2224 49.9141 64.8688L52.3943 62.3299Z",
    fill: "#181D1B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M134.839 60.3161C134.839 60.3161 147.118 71.0041 153.057 90.5432C153.057 90.5432 158.96 111.164 149.073 118.245C149.073 118.245 141.002 123.919 135.624 115.31C135.624 115.31 140.422 78.4871 130.321 57.7014C130.321 57.7014 130.173 56.6596 130.799 56.667C131.351 56.6573 132.506 57.4251 134.839 60.3161Z",
    fill: "url(#paint5_linear_14011_169619)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M139.294 116.067C140.451 116.323 141.021 118.191 140.555 120.234C140.094 122.278 138.783 123.718 137.622 123.461C136.465 123.2 135.895 121.332 136.361 119.294C136.785 117.408 137.934 116.035 139.018 116.035C139.113 116.035 139.204 116.044 139.294 116.067Z",
    fill: "url(#paint6_linear_14011_169619)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M147.47 119.503C147.723 121.58 146.976 123.382 145.795 123.526C144.619 123.669 143.452 122.102 143.198 120.026C142.94 117.949 143.688 116.147 144.868 116.003C144.916 115.999 144.969 115.994 145.017 115.994C146.145 115.994 147.22 117.514 147.47 119.503Z",
    fill: "url(#paint7_linear_14011_169619)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M153.203 115.732C153.461 117.808 152.713 119.61 151.532 119.754C150.352 119.897 149.189 118.33 148.931 116.254C148.678 114.178 149.425 112.375 150.606 112.232C150.654 112.227 150.706 112.223 150.754 112.223C151.882 112.223 152.958 113.742 153.203 115.732Z",
    fill: "url(#paint8_linear_14011_169619)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M134.395 59.7721C134.395 59.7721 139.996 100.622 138.378 116.037C138.378 116.037 140.353 115.759 140.528 117.473C140.528 117.473 140.943 91.6645 136.875 62.3109L134.395 59.7721Z",
    fill: "#181D1B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5459 90.5269C92.7859 95.936 89.6447 115.804 88.3059 123.469C88.0484 125.058 89.2585 126.494 90.8806 126.494H101.54C104.887 126.494 105.067 121.52 101.72 121.315C101.257 121.29 100.819 121.264 100.381 121.264C98.1414 121.238 96.9828 118.649 98.4246 116.957C107.05 106.908 112.302 93.5262 113.873 89.1938C114.337 87.8864 113.693 86.4508 112.405 85.9125C110.5 85.1434 107.436 84.7589 104.192 84.7589C97.0085 84.7589 88.9496 86.6559 90.5459 90.5269Z",
    fill: "url(#paint9_linear_14011_169619)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5853 125.175C60.2979 125.713 59.6543 127.149 60.1177 128.456C61.6883 132.789 66.9409 146.171 75.5665 156.22C77.0083 157.912 75.8497 160.501 73.6096 160.527C73.1719 160.527 72.7342 160.553 72.2707 160.578C68.9235 160.783 69.1037 165.757 72.451 165.757H83.1106C84.7327 165.757 85.9429 164.321 85.6854 162.732C84.3465 155.067 81.2052 135.199 83.4453 129.789C85.0417 125.918 76.9826 124.021 69.7989 124.021C66.5547 124.021 63.4907 124.406 61.5853 125.175Z",
    fill: "url(#paint10_linear_14011_169619)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M105.897 129.789C108.137 135.199 104.996 155.067 103.657 162.732C103.4 164.321 104.61 165.757 106.232 165.757H116.892C120.239 165.757 120.419 160.783 117.072 160.578C116.608 160.553 116.171 160.527 115.733 160.527C113.493 160.501 112.334 157.912 113.776 156.22C122.402 146.171 127.654 132.789 129.225 128.456C129.688 127.149 129.045 125.713 127.757 125.175C125.852 124.406 122.788 124.021 119.544 124.021C112.36 124.021 104.301 125.918 105.897 129.789Z",
    fill: "url(#paint11_linear_14011_169619)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M121.45 21.5275C117.738 23.9555 110.358 33.1302 112.818 36.8044C115.257 40.4785 126.608 37.2771 130.32 34.8491C134.01 32.3996 135.024 27.4578 132.564 23.7621C131.01 21.4416 128.464 20.1953 125.874 20.1953C124.342 20.1953 122.81 20.6251 121.45 21.5275Z",
    fill: "url(#paint12_linear_14011_169619)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M132.212 29.6786C132.212 25.932 130.334 23.6963 125.781 23.696C121.228 23.6957 119.509 29.1936 119.509 31.5361C119.509 34.4642 120.655 36.007 124.699 36.007C128.742 36.007 132.212 33.4252 132.212 29.6786Z",
    fill: "url(#paint13_linear_14011_169619)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M54.131 23.7621C51.6924 27.4578 52.6851 32.3996 56.3753 34.8491C60.0871 37.2771 71.4382 40.4785 73.8767 36.8044C76.3368 33.1302 68.9565 23.9555 65.2447 21.5275C63.8852 20.6251 62.353 20.1953 60.8208 20.1953C58.2312 20.1953 55.6848 21.4416 54.131 23.7621Z",
    fill: "url(#paint14_linear_14011_169619)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4866 29.6786C54.4866 25.932 56.3639 23.6963 60.917 23.696C65.4701 23.6957 67.1893 29.1936 67.1893 31.5361C67.1893 34.4642 66.0429 36.007 61.9997 36.007C57.9564 36.007 54.4866 33.4252 54.4866 29.6786Z",
    fill: "url(#paint15_linear_14011_169619)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.708 11.7482C96.708 15.439 95.4804 18.431 93.9662 18.431C92.4519 18.431 91.2244 15.439 91.2244 11.7482C91.2244 8.05741 92.4519 5.06543 93.9662 5.06543C95.4804 5.06543 96.708 8.05741 96.708 11.7482Z",
    fill: "url(#paint16_linear_14011_169619)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2487 13.0151C94.0837 16.006 93.326 19.1496 94.5528 20.0298C95.7796 20.91 98.531 19.2035 100.705 16.2036C102.87 13.2127 103.628 10.0692 102.401 9.18895C102.184 9.03626 101.914 8.95543 101.607 8.95543C100.209 8.95543 98.0348 10.5542 96.2487 13.0151Z",
    fill: "url(#paint17_linear_14011_169619)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5325 9.18946C84.3058 10.0696 85.0635 13.213 87.2283 16.2036C89.4021 19.2033 92.1533 20.9097 93.38 20.0296C94.6067 19.1494 93.849 16.0061 91.6842 13.0154C89.8982 10.5546 87.7244 8.95596 86.3263 8.95596C86.0196 8.95596 85.749 9.03679 85.5325 9.18946Z",
    fill: "url(#paint18_linear_14011_169619)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4086 33.5145C59.4086 33.5145 48.6979 60.6271 48.3348 112.141C48.3348 112.141 43.7963 154.256 93.9008 154.165C93.9008 154.165 130.935 156.967 138.196 125.968C138.196 125.968 141.464 97.5001 134.928 61.6212C134.928 61.6212 129.301 36.4065 125.942 28.815C125.942 28.815 118.227 15.078 93.9008 14.4454C93.9008 14.4454 93.6285 14.355 93.1747 14.355C88.9993 14.355 67.3055 15.2587 59.4086 33.5145Z",
    fill: "url(#paint19_linear_14011_169619)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 93.5364,
    cy: 47.6295,
    rx: 33.2432,
    ry: 31.1044,
    fill: "url(#paint20_linear_14011_169619)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M122.37 85.7993C122.37 93.4232 109.576 99.6047 93.7917 99.6047C78.0098 99.6047 65.2139 91.5722 65.2139 85.7993C65.2139 78.166 78.0098 83.9215 93.7917 83.9215C109.576 83.9215 122.37 78.166 122.37 85.7993Z",
    fill: "#FFF8E1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9657 82.5541C78.1875 82.5541 65.3835 76.7995 65.3835 84.4233C65.3835 92.0472 78.1875 98.2428 93.9657 98.2428C109.744 98.2428 122.548 92.0472 122.548 84.4233C122.548 81.378 120.502 80.4749 117.063 80.4749C111.874 80.4749 103.458 82.5541 93.9657 82.5541Z",
    fill: "url(#paint21_linear_14011_169619)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6697 96.6537C84.6438 97.6666 89.1599 98.2346 93.9707 98.2346C98.6959 98.2346 103.155 97.6855 107.082 96.701C104.686 94.874 100.959 92.5075 98.9241 93.5393C95.7771 95.158 92.6967 94.8551 90.4339 93.6908C89.8254 93.3689 89.0268 93.1796 88.095 93.1796C86.0509 93.1796 83.3698 94.1073 80.6697 96.6537Z",
    fill: "url(#paint22_radial_14011_169619)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M98.2176 105.452C96.8753 105.611 95.4524 105.702 93.9663 105.702C92.665 105.702 91.4104 105.632 90.2143 105.508C79.011 104.152 73.7858 99.0107 75.7536 99.5625C77.3764 99.7418 82.4122 101.948 88.8043 102.684C90.4622 102.881 92.202 102.993 93.9663 102.986C95.8733 102.994 97.7546 102.863 99.5329 102.631C105.737 101.857 110.589 99.7348 112.179 99.5625C114.109 99.0293 109.088 103.98 98.2176 105.452Z",
    fill: "#181D1B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0111 80.5894C68.9735 80.8369 68.9584 81.0844 68.9584 81.3506C68.9584 83.893 70.5741 85.948 72.5703 85.948C74.5626 85.948 76.1821 83.893 76.1821 81.3506C76.1821 81.2006 76.1746 81.0506 76.1595 80.9006C74.1634 80.6494 72.3857 80.4731 70.8754 80.4731C70.1975 80.4731 69.5761 80.5069 69.0111 80.5894Z",
    fill: "url(#paint23_linear_14011_169619)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M70.557 84.7131C71.0118 85.2403 71.5985 85.4804 71.8702 85.2488C72.1404 85.017 71.9943 84.4013 71.5402 83.875C71.087 83.348 70.4988 83.1061 70.2287 83.3379C69.956 83.5703 70.1038 84.1861 70.557 84.7131Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7437 81.3517C77.7442 83.8937 79.3594 85.9486 81.3535 85.9497C83.1806 85.9487 84.6778 84.2448 84.9325 82.0162C82.3556 81.7347 79.9483 81.3922 77.7568 81.103C77.7428 81.1817 77.7414 81.2682 77.7437 81.3517Z",
    fill: "url(#paint24_linear_14011_169619)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3441 84.7131C79.798 85.2411 80.3856 85.4804 80.6574 85.2488C80.9275 85.017 80.7814 84.4013 80.3273 83.875C79.8724 83.3478 79.2859 83.1061 79.0149 83.3386C78.7431 83.5703 78.8909 84.1861 79.3441 84.7131Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1439 85.949C91.8105 85.949 93.2179 84.5141 93.63 82.5529C91.1962 82.54 88.8402 82.3877 86.5905 82.1813C86.8963 84.3232 88.3685 85.949 90.1439 85.949Z",
    fill: "url(#paint25_linear_14011_169619)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1317 84.7129C88.5852 85.2397 89.1736 85.4796 89.4436 85.2476C89.7144 85.0166 89.5688 84.4003 89.1144 83.8742C88.6602 83.3465 88.0719 83.105 87.8026 83.3378C87.531 83.5697 87.6775 84.1852 88.1317 84.7129Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M95.442 82.5303C95.8475 84.5013 97.2615 85.949 98.9343 85.949C100.732 85.949 102.232 84.2729 102.501 82.0708C100.258 82.3045 97.8885 82.4799 95.442 82.5303Z",
    fill: "url(#paint26_linear_14011_169619)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M96.919 84.7133C97.3716 85.2408 97.9601 85.4807 98.2301 85.2488C98.5017 85.017 98.3553 84.4014 97.9009 83.8754C97.4466 83.3477 96.8591 83.1054 96.5883 83.3381C96.3166 83.5699 96.4631 84.1855 96.919 84.7133Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M104.129 81.8885C104.339 84.174 105.863 85.9502 107.723 85.9491C109.717 85.9483 111.334 83.894 111.332 81.3529C111.332 81.2158 111.326 81.0825 111.313 80.9532C109.143 81.2277 106.728 81.5856 104.129 81.8885Z",
    fill: "url(#paint27_linear_14011_169619)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M105.705 84.7131C106.16 85.2403 106.746 85.4804 107.018 85.2488C107.288 85.017 107.142 84.4013 106.688 83.875C106.233 83.3478 105.648 83.1053 105.376 83.3386C105.105 83.5704 105.252 84.1861 105.705 84.7131Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M112.922 80.7583C112.904 80.9532 112.888 81.1482 112.888 81.3507C112.888 83.8931 114.508 85.948 116.5 85.948C118.496 85.948 120.12 83.8931 120.12 81.3507C120.12 81.182 120.116 81.017 120.101 80.8557C119.272 80.582 118.24 80.4733 117.043 80.4733C115.834 80.4733 114.451 80.5858 112.922 80.7583Z",
    fill: "url(#paint28_linear_14011_169619)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M114.493 84.7131C114.947 85.2411 115.535 85.4804 115.806 85.2488C116.077 85.017 115.93 84.4013 115.476 83.875C115.023 83.348 114.435 83.1061 114.164 83.3386C113.892 83.5703 114.04 84.1861 114.493 84.7131Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M92.6073 51.4669C92.6073 60.2678 85.4424 67.4016 76.6043 67.4016C67.7675 67.4016 60.6014 60.2678 60.6014 51.4669C60.6014 42.6684 67.7675 35.5346 76.6043 35.5346C85.4424 35.5346 92.6073 42.6684 92.6073 51.4669Z",
    fill: "#181D1B"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.5694 51.4681C91.5694 59.6983 84.8685 66.3701 76.6025 66.3701C68.3365 66.3701 61.6356 59.6983 61.6356 51.4681C61.6356 43.238 68.3365 36.5662 76.6025 36.5662C84.8685 36.5662 91.5694 43.238 91.5694 51.4681Z",
    fill: "url(#paint29_radial_14011_169619)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.6556 51.4663C84.6556 55.8937 81.0508 59.4828 76.6041 59.4828C72.1574 59.4828 68.5526 55.8937 68.5526 51.4663C68.5526 47.0388 72.1574 43.4497 76.6041 43.4497C81.0508 43.4497 84.6556 47.0388 84.6556 51.4663Z",
    fill: "url(#paint30_radial_14011_169619)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3704 51.4664C80.3704 53.5385 78.6855 55.2161 76.6043 55.2161C74.5243 55.2161 72.8383 53.5385 72.8383 51.4664C72.8383 49.3954 74.5243 47.7167 76.6043 47.7167C78.6855 47.7167 80.3704 49.3954 80.3704 51.4664Z",
    fill: "#2D2A49"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.605,
    cy: 47.5067,
    rx: 4.48271,
    ry: 3.42953,
    fill: "url(#paint31_linear_14011_169619)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M126.78 51.4669C126.78 60.2678 119.615 67.4016 110.777 67.4016C101.94 67.4016 94.7737 60.2678 94.7737 51.4669C94.7737 42.6684 101.94 35.5346 110.777 35.5346C119.615 35.5346 126.78 42.6684 126.78 51.4669Z",
    fill: "#181D1B"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.742 51.4681C125.742 59.6983 119.041 66.3701 110.775 66.3701C102.509 66.3701 95.8079 59.6983 95.8079 51.4681C95.8079 43.238 102.509 36.5662 110.775 36.5662C119.041 36.5662 125.742 43.238 125.742 51.4681Z",
    fill: "url(#paint32_radial_14011_169619)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.828 51.4665C118.828 55.8939 115.224 59.4831 110.777 59.4831C106.33 59.4831 102.725 55.8939 102.725 51.4665C102.725 47.0391 106.33 43.45 110.777 43.45C115.224 43.45 118.828 47.0391 118.828 51.4665Z",
    fill: "url(#paint33_radial_14011_169619)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M114.543 51.4664C114.543 53.5385 112.858 55.2161 110.777 55.2161C108.697 55.2161 107.011 53.5385 107.011 51.4664C107.011 49.3954 108.697 47.7167 110.777 47.7167C112.858 47.7167 114.543 49.3954 114.543 51.4664Z",
    fill: "#2D2A49"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.777,
    cy: 47.5067,
    rx: 4.48272,
    ry: 3.42953,
    fill: "url(#paint34_linear_14011_169619)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M98.3673 96.5787C98.3673 97.0607 96.451 97.4507 94.0868 97.4507C91.7227 97.4507 89.8075 97.0607 89.8075 96.5787C89.8075 96.098 91.7227 95.708 94.0868 95.708C96.451 95.708 98.3673 96.098 98.3673 96.5787Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M105.12 153.536C105.12 153.536 110.627 152.885 118.72 149.635C118.72 149.635 116.505 152.801 115.126 154.601C115.126 154.601 111.079 156.433 104.71 156.433L105.12 153.536Z",
    fill: "#181D1B"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M84.2255 153.55C84.2255 153.55 79.1428 153.522 71.0484 150.273C71.0484 150.273 72.7658 152.834 74.2103 154.575C74.2103 154.575 77.6971 156.094 84.6532 156.461L84.2255 153.55Z",
    fill: "#181D1B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_14011_169619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(93.5117 166.313) rotate(90) scale(13.8766 60.5898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14011_169619",
    x1: 38.1114,
    y1: 66.0187,
    x2: 56.509,
    y2: 66.3429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F81B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14011_169619",
    x1: 33.5345,
    y1: 114.781,
    x2: 37.9066,
    y2: 114.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FCF4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F3B98E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3B98E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14011_169619",
    x1: 39.2717,
    y1: 118.551,
    x2: 43.6439,
    y2: 118.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FCF4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F3B98E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3B98E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_14011_169619",
    x1: 46.0717,
    y1: 118.594,
    x2: 50.5917,
    y2: 118.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FCF4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F3B98E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3B98E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_14011_169619",
    x1: 148.678,
    y1: 63.4609,
    x2: 130.281,
    y2: 63.7851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F81B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_14011_169619",
    x1: 140.718,
    y1: 116.036,
    x2: 136.198,
    y2: 116.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FCF4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F3B98E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3B98E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_14011_169619",
    x1: 147.518,
    y1: 115.994,
    x2: 143.145,
    y2: 115.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FCF4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F3B98E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3B98E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_14011_169619",
    x1: 153.255,
    y1: 112.223,
    x2: 148.883,
    y2: 112.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FCF4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F3B98E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3B98E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_14011_169619",
    x1: 88.2801,
    y1: 84.7636,
    x2: 114.028,
    y2: 84.7636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FA7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0071BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_14011_169619",
    x1: 59.9632,
    y1: 124.024,
    x2: 85.7111,
    y2: 124.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F81B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_14011_169619",
    x1: 129.379,
    y1: 124.024,
    x2: 103.632,
    y2: 124.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F81B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_14011_169619",
    x1: 133.902,
    y1: 18.5932,
    x2: 112.322,
    y2: 18.5932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F81B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_14011_169619",
    x1: 119.509,
    y1: 30.0703,
    x2: 132.212,
    y2: 30.0703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F86C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02A2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_14011_169619",
    x1: 52.793,
    y1: 18.5923,
    x2: 74.3731,
    y2: 18.5923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F81B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_14011_169619",
    x1: 67.1893,
    y1: 30.0703,
    x2: 54.4863,
    y2: 30.0703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F86C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02A2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_14011_169619",
    x1: 91.2251,
    y1: 5.06473,
    x2: 96.7087,
    y2: 5.06473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F81B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_14011_169619",
    x1: 93.9665,
    y1: 8.958,
    x2: 102.987,
    y2: 8.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F81B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_14011_169619",
    x1: 84.9462,
    y1: 8.95848,
    x2: 93.9663,
    y2: 8.95848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F81B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_14011_169619",
    x1: 48.244,
    y1: 14.3673,
    x2: 139.013,
    y2: 14.3673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F81B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_14011_169619",
    x1: 93.5364,
    y1: 16.5251,
    x2: 93.5364,
    y2: 54.6625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_14011_169619",
    x1: 122.548,
    y1: 75.5184,
    x2: 122.548,
    y2: 96.5206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE1722"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_14011_169619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(93.8756 95.707) scale(9.5075 3.40757)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD721B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC1A21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_14011_169619",
    x1: 70.0957,
    y1: 85.6555,
    x2: 70.0957,
    y2: 81.9056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D9DADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_14011_169619",
    x1: 78.6908,
    y1: 85.5414,
    x2: 78.8761,
    y2: 82.2346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D9DADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_14011_169619",
    x1: 87.6988,
    y1: 85.7477,
    x2: 87.6988,
    y2: 83.1671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D9DADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_14011_169619",
    x1: 96.5531,
    y1: 85.7418,
    x2: 96.5531,
    y2: 83.0855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D9DADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_14011_169619",
    x1: 105.122,
    y1: 85.7919,
    x2: 104.977,
    y2: 82.3782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D9DADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_14011_169619",
    x1: 114.029,
    y1: 85.6555,
    x2: 114.029,
    y2: 81.9057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D9DADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_14011_169619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.604 51.4666) scale(14.9669 14.902)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_14011_169619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.6037 51.4666) scale(8.05149 8.01656)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#8DD5B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A156"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_14011_169619",
    x1: 76.6132,
    y1: 44.0771,
    x2: 76.6132,
    y2: 47.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_14011_169619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(110.776 51.4668) scale(14.9669 14.902)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_14011_169619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(110.777 51.4665) scale(8.05149 8.01656)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#8DD5B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A156"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_14011_169619",
    x1: 110.785,
    y1: 44.0771,
    x2: 110.785,
    y2: 47.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonster5);
export default __webpack_public_path__ + "static/media/Monster5.0c6b68732b0afd47e6c7e64e97ad360a.svg";
export { ForwardRef as ReactComponent };